import React, { CSSProperties } from 'react';

export enum Align {
    SPACE_BETWEEN,
    END
}

interface Props {
    children: React.ReactElement | React.ReactElement[];
    align?: Align;
    gap?: number;
    style?: CSSProperties;
    className?: string;
}

const toJustify = (align?: Align) => {
    switch (align) {
        case Align.SPACE_BETWEEN: return 'space-between';
        case Align.END: return 'flex-end';
    }
}

export function Row({
                        children,
                        gap,
                        style,
                        className,
                        align
                    }: Props) {

    return (
        <div className={className} style={{
            display: 'flex',
            gap: (gap || 0) + 'px',
            alignItems: 'center',
            justifyContent: toJustify(align),
            ...style
        }}>{children}</div>
    );
}
